import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = [ 'clinicsFilter', 'doctorsFilter', 'reviewsList', 'moreButton', 'resetButton', 'empty' ]

  connect() {
    this.hiddenClass = 'hidden'
    this.reset()
  }

  changeClinic(e) {
    this.clinicCurrent = e.detail.value
    this.doctorCurrent = ''
    if (this.hasDoctorsFilterTarget && this.doctorsFilterTarget.filter) { this.doctorsFilterTarget.filter.reset() }

    this.fetchData().then(data => {
      if (this.hasDoctorsFilterTarget && this.doctorsFilterTarget.filter) { this.doctorsFilterTarget.filter.update(data.doctors) }
      this.reviewsListTarget.innerHTML = data.reviews
      this.handleMoreButton(data.hasMore)
      this.showEmpty(data.reviews.length)
    })
  }

  changeDoctor(e) {
    this.doctorCurrent = e.detail.value
    this.fetchData().then(data => {
      this.reviewsListTarget.innerHTML = data.reviews
      this.handleMoreButton(data.hasMore)
      this.showEmpty(data.reviews.length)
    })
  }

  nextPage(e) {
    e.preventDefault()
    this.pageCurrent += 1
    this.fetchData(this.pageCurrent).then(data => {
      this.reviewsListTarget.innerHTML += data.reviews
      this.handleMoreButton(data.hasMore)
      this.showEmpty(data.reviews.length)
    })
  }

  fetchData(page = 1) {
    const params = new URLSearchParams({
      clinic_id: this.clinicCurrent,
      doctor_id: this.doctorCurrent,
      page: page
    })
    return fetch(`${this.data.get('url')}?${params}`, {
      headers: {
        accept: "application/json"
      }
    }).then(response => response.json())
  }

  reset() {
    this.clearData()
    if (this.hasClinicsFilterTarget && this.clinicsFilterTarget.filter) { this.clinicsFilterTarget.filter.reset() }
    if (this.hasDoctorsFilterTarget && this.doctorsFilterTarget.filter) { this.doctorsFilterTarget.filter.reset() }

    this.fetchData().then(data => {
      if (this.hasClinicsFilterTarget && this.clinicsFilterTarget.filter) { this.clinicsFilterTarget.filter.update(data.clinics) }
      if (this.hasDoctorsFilterTarget && this.doctorsFilterTarget.filter) { this.doctorsFilterTarget.filter.update(data.doctors) }
      if (this.hasReviewsListTarget) { this.reviewsListTarget.innerHTML = data.reviews }
      this.handleMoreButton(data.hasMore)
      this.showEmpty(data.reviews.length)
    })
  }

  clearData() {
    this.clinicCurrent = ''
    this.doctorCurrent = ''
    this.pageCurrent = 1
  }

  handleMoreButton(hasMore) {
    if (hasMore) {
      this.moreButtonTarget.classList.remove(this.hiddenClass)
    } else {
      this.moreButtonTarget.classList.add(this.hiddenClass)
    }
  }

  showEmpty(empty) {
    if (empty) {
      this.emptyTarget.classList.add(this.hiddenClass)
    } else {
      this.emptyTarget.classList.remove(this.hiddenClass)
    }
  }
}
